import { defaultDropAnimation, type DropAnimation } from "@dnd-kit/core";
import { useIsReducedMotion } from "@design-system/Board/boardMotion";

// dnd-kit animates in JS, so it takes the values of `--duration-medium` and
// `--ease-in-out` (styles/tokens/_motion.scss) rather than the variables.
const COLUMN_REORDER_TRANSITION = {
    duration: 160,
    easing: "cubic-bezier(0.77, 0, 0.175, 1)",
};

const COLUMN_DROP_ANIMATION: DropAnimation = {
    ...defaultDropAnimation,
    ...COLUMN_REORDER_TRANSITION,
};

/** How neighbouring rows slide during a reorder; null (instant) under reduced motion. */
export const useColumnReorderTransition = () =>
    useIsReducedMotion() ? null : COLUMN_REORDER_TRANSITION;

/** How the dragged row settles into its slot; null (instant) under reduced motion. */
export const useColumnDropAnimation = () =>
    useIsReducedMotion() ? null : COLUMN_DROP_ANIMATION;
